import { Col, Form } from "antd";
import { FormBox } from "../../../../../components/AntdAddons";
import SaveButton from "../../../../../components/Buttons/SaveButton";
import { useEffect, useState } from "react";
import {
  toUpperCaseWithUnderscore,
  validateFields,
} from "../../../../../utils/commonFunctions";
import { updateRecord } from "../utils/slice";
import * as CommonSlice from "../utils/slice";
import { assignErrorToInput } from "../../../../../store/api";
import { dataToFormDataConverter } from "../../../../../config/Global";
import { useAppDispatch } from "../../../../../utils/hooks/hooks";

interface ISectionWrapper {
  sectionName: string;
  sectionKey: string;
  details?: any;
  formItems: React.FC<any>;
}

const SectionWrapper: React.FC<ISectionWrapper> = ({
  sectionName,
  sectionKey,
  details,
  formItems: FormItems,
}) => {
  const dispatch = useAppDispatch();

  const [form] = Form.useForm();
  const [disabled, setDisabled] = useState<boolean>(true);
  const [saving, setSaving] = useState<boolean>(false);

  useEffect(() => {
    form.setFieldsValue(details);
  }, [form, details]);

  const onValuesChange = (data: any) => {
    Object.entries(data).forEach(([key, value]: any) => {
      let currentValue = null;
      if (value) {
        if (value.fileList) {
          if (value.fileList.length > 0) {
            currentValue = value.fileList[0].originFileObj;
          }
        } else {
          currentValue = value;
        }
      }

      form.setFieldsValue({
        [key]: currentValue ?? "",
      });
    });
    validateFields(form, setDisabled);
    console.log(form)
  };

  const onFinish = (data: any) => {
    data.section = sectionKey;

    if (data?.cc_hint_document && data?.cc_hint_document == details.cc_hint_document) {
      delete data.cc_hint_document;
    }
    if (data?.cc_hint_document_spanish && data?.cc_hint_document_spanish == details.cc_hint_document_spanish) {
      delete data.cc_hint_document_spanish;
    }
    if (data?.banner_logo && data?.banner_logo == details.banner_logo) {
      delete data.banner_logo;
    }
    if (data?.compass_video_youtube_url && data?.compass_video_youtube_url == details.compass_video_youtube_url) {
      delete data.compass_video_youtube_url;
    }
    if (
      Object.prototype.hasOwnProperty.call(data, "is_visible_counter_section")
    ) {
      data.is_visible = data.is_visible_counter_section;
    }
    if (Object.prototype.hasOwnProperty.call(data, "is_visible_4")) {
      data.is_visible = data.is_visible_4;
    }
    if (Object.prototype.hasOwnProperty.call(data, "is_visible_5")) {
      data.is_visible = data.is_visible_5;
    }

    setSaving(true);
    setDisabled(true);
    dispatch(updateRecord(dataToFormDataConverter(data)))
      .then(() => {
        if (data?.cc_hint_document || data?.cc_hint_document_spanish) {
          dispatch(CommonSlice.details()).then(() => form.validateFields()).finally(() => setSaving(false));
        }
        else {
          setSaving(false);
        }
      })
      .catch((error: any) => {
        assignErrorToInput(form, error?.STATUS);
      })

  };

  return (
    <>
      <br />
      <br />
      <Col xs={{ span: 24 }}>
        <div className="SectionTitle">
          <h2>{sectionName}:</h2>
        </div>
      </Col>
      <br />
      <div className="homeSettingForm">
        <FormBox
          form={form}
          id={toUpperCaseWithUnderscore(sectionName)}
          onFinish={onFinish}
          onValuesChange={onValuesChange}
        >
          <FormItems form={form} sectionDetails={details} />
        </FormBox>
        <SaveButton
          form={toUpperCaseWithUnderscore(sectionName)}
          disabled={disabled}
          loading={saving}
        />
      </div>
    </>
  );
};

export default SectionWrapper;
